import { render, staticRenderFns } from "./ProductComponent.vue?vue&type=template&id=35e2aa0b&scoped=true&"
import script from "./ProductComponent.vue?vue&type=script&lang=ts&"
export * from "./ProductComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ProductComponent.vue?vue&type=style&index=0&id=35e2aa0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e2aa0b",
  null
  
)

export default component.exports